import React, { useEffect, useRef } from "react";
import L from "leaflet";
import 'leaflet/dist/leaflet.css';
import { clearLayerLegend, createControl, createMap, initMinimalMap, initOutlineCity } from "../../utils/map/mapUtils";
require("../../utils/leaflet/Leaflet.VectorGrid.bundled");

export const ImmobilierMap = ({immoItem, locationInfos, outlineCity}) => {
    const mapRef = useRef(undefined);
    const overlaysGroupRef = useRef(undefined);
    const legendRef = useRef(undefined);
    const outlineCityRef = useRef(undefined);

    const formatter = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", minimumFractionDigits: 0, maximumFractionDigits: 0})
    const colors = immoItem && immoItem.codeInsee != '75056'
        ? ["#EBED8C", "#EADA4A", "#E3B130", "#FF0000", "#8E0000"]
        : ["#EAEC83", "#DBDB04", "#FFCE03", "#FD9A01", "#D94500", "#FF2C05", "#F00505", "#980404", "#590303", "#230000"];

    const getColorSector = (nb) => {
        const thresholdsNb = immoItem.codeInsee != '75056' ? 5 : 10;
        const prices = immoItem.data.estimates.map(e => e.prix_m2);
        const part = (Math.max(...prices) - Math.min(...prices))/ thresholdsNb;
        const thresholds = Array.from({length: thresholdsNb}, (_, i) => Math.min(...prices) + (part*i)).filter(i => nb > i)

        return thresholds.length > 0 ? colors[thresholds.length - 1] : colors[0];
    }

    useEffect(() => {
        if(immoItem && immoItem.data && outlineCity){
            mapRef.current = createMap('immobilier');
            legendRef.current = createControl('topleft', false, true);
            outlineCityRef.current = initOutlineCity(outlineCity.COM);
            overlaysGroupRef.current = L.layerGroup().addTo(mapRef.current);

            const com = immoItem.data.communes.features.find(feature => feature.properties.com == immoItem.codeInsee);
            initMinimalMap(mapRef.current, legendRef.current, outlineCityRef.current, {...locationInfos, com: com ? com.properties : undefined});
        }
    }, [])

    useEffect(() => {
        if(mapRef.current && legendRef.current){
            overlaysGroupRef.current.clearLayers();
            mapRef.current.fitBounds(locationInfos.address 
                ? L.latLngBounds([locationInfos.address.lat + 0.03, locationInfos.address.lon + 0.03], [locationInfos.address.lat - 0.03, locationInfos.address.lon - 0.03])
                : outlineCityRef.current.getBounds()
            );
            if(immoItem && immoItem.data && immoItem.data.estimates.length > 0){
                const communes = immoItem.data.communes;
                const irisFeatures = immoItem.data.iris.features;
                irisFeatures.map(feature => {
                    const { properties } = feature;
                    const estimate = immoItem.data.estimates.find(e => e.num_iris === properties.codeIris)
                    const multipleComs = communes && communes.features && (communes.features.length > 1);
                    const commune = communes.features.find(c => properties.codeIris.startsWith(c.properties.com));
                    const libelle = ((multipleComs && commune && properties.typeIris.code !== 'Z') ? commune.properties.libelle + ' - ' + properties.libelleIris : properties.libelleIris);

                    feature.properties = {
                        ...properties,
                        prix_m2: estimate ? estimate.prix_m2 : undefined,
                        nb_ventes: estimate ? estimate.nb_ventes : undefined,
                        color: estimate ? getColorSector(estimate.prix_m2) : '#000',
                        label: estimate ? `${formatter.format(estimate.prix_m2)} / m²` : undefined,
                        libelleIris: libelle
                    }
                    return feature;
                })

                overlaysGroupRef.current.addLayer(
                    L.geoJSON(irisFeatures, {
                        style: (feature) =>  ({
                            color: feature.properties.color,
                            weight: 1,
                            fillOpacity: 0.7,
                            fill: true,
                        }),
                        onEachFeature: (feature, layer) => layer.bindPopup(feature.properties.libelleIris ? `<p>${feature.properties.libelleIris}<br/>${feature.properties.label}</p>` : feature.properties.label)
                    })
                )

                if(outlineCity.ARM.length > 0){
                    overlaysGroupRef.current.addLayer(L.geoJSON(outlineCity.ARM, {
                        style: {
                            color: "#918F8F",
                            weight: 2,
                            fill: false,
                            dashArray: "4"
                        }
                    }));
                }
                outlineCityRef.current.bringToFront();
            }
        }
    }, [immoItem])
    return (
        <div className="dashboard-map">
            {immoItem && 
                <div
                    id={`immobilier-map`}
                    style={{ height: '100%'}}
                    role="img"
                    aria-label='Carte des tarifs immobiliers de la ville'
                >
                </div>
            }
        </div>
    )
}